import useConfigs from "./useConfigs";

const useThemes = () => {
  const { activeTheme } = useConfigs();

  const backgroundWhite = {
    DEFAULT: activeTheme?.color_base_blanco,
    ROSADO: activeTheme?.color_base_3,
    DARK: activeTheme?.color_base_3,
  };

  const backgroundSecundario = {
    DEFAULT: activeTheme?.color_base_4,
    ROSADO: activeTheme?.color_base_2,
    DARK: activeTheme?.color_base_2,
  };

  const backgroundBtn = {
    DEFAULT: activeTheme?.color_base_3,
    ROSADO: activeTheme?.color_base_ppal,
    DARK: activeTheme?.color_base_ppal,
  };

  const backgroundTercero = {
    DEFAULT: activeTheme?.color_base_secundario,
    ROSADO: activeTheme?.color_base_2,
    DARK: activeTheme?.color_base_2,
  };

  const backgroundCuarto = {
    DEFAULT: activeTheme?.color_base_secundario,
    ROSADO: activeTheme?.color_base_1,
    DARK: activeTheme?.color_base_1,
  };

  const backgroundQuinto = {
    DEFAULT: activeTheme?.color_base_blanco,
    ROSADO: activeTheme?.color_base_2,
    DARK: activeTheme?.color_base_2,
  };

  const backgroundSexto = {
    DEFAULT: activeTheme?.color_base_4,
    ROSADO: activeTheme?.color_base_3,
    DARK: activeTheme?.color_base_3,
  };

  const backgroundSeptimo = {
    DEFAULT: activeTheme?.color_base_blanco,
    ROSADO: activeTheme?.color_base_1,
    DARK: activeTheme?.color_base_1,
  };

  const backgroundOctavo = {
    DEFAULT: activeTheme?.color_base_ppal,
    ROSADO: activeTheme?.color_base_1,
    DARK: activeTheme?.color_base_1,
  };

  const backgroundNoveno = {
    DEFAULT: "transparent",
    ROSADO: activeTheme?.color_base_2,
    DARK: activeTheme?.color_base_2,
  };

  const backgroundDecimo = {
    DEFAULT: activeTheme?.color_base_secundario,
    ROSADO: activeTheme?.color_base_3,
    DARK: activeTheme?.color_base_3,
  };

  const colorPrincipal = {
    DEFAULT: activeTheme?.color_base_ppal,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  const colorSecundario = {
    DEFAULT: activeTheme?.color_base_4,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  const colorTercero = {
    DEFAULT: activeTheme?.color_base_2,
    ROSADO: activeTheme?.color_base_ppal,
    DARK: activeTheme?.color_base_ppal,
  };

  const colorCuarto = {
    DEFAULT: activeTheme?.color_base_tipografia,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  const colorQuinto = {
    DEFAULT: activeTheme?.color_base_secundario,
    ROSADO: activeTheme?.color_base_tipografia,
    DARK: activeTheme?.color_base_tipografia,
  };

  const colorSexto = {
    DEFAULT: activeTheme?.color_base_4,
    ROSADO: activeTheme?.color_base_primario,
    DARK: activeTheme?.color_base_primario,
  };

  const colorSeptimo = {
    DEFAULT: activeTheme?.color_base_primario,
    ROSADO: activeTheme?.color_base_2,
    DARK: activeTheme?.color_base_2,
  };

  const logo = {
    DEFAULT: "img/famedic-logo.png",
    ROSADO: "img/Famedic-blanco.png",
    DARK: "img/Famedic-blanco.png",
  };

  const imgLineas = {
    DEFAULT: "img/Grupo363.png",
    ROSADO: "img/Grupo364.png",
    DARK: "img/Grupo364.png",
  };

  return {
    backgroundWhite: backgroundWhite[activeTheme?.nombre],
    backgroundSecundario: backgroundSecundario[activeTheme?.nombre],
    backgroundBtn: backgroundBtn[activeTheme?.nombre],
    backgroundTercero: backgroundTercero[activeTheme?.nombre],
    backgroundCuarto: backgroundCuarto[activeTheme?.nombre],
    backgroundQuinto: backgroundQuinto[activeTheme?.nombre],
    backgroundSexto: backgroundSexto[activeTheme?.nombre],
    backgroundSeptimo: backgroundSeptimo[activeTheme?.nombre],
    backgroundOctavo: backgroundOctavo[activeTheme?.nombre],
    backgroundNoveno: backgroundNoveno[activeTheme?.nombre],
    backgroundDecimo: backgroundDecimo[activeTheme?.nombre],
    colorPrincipal: colorPrincipal[activeTheme?.nombre],
    colorSecundario: colorSecundario[activeTheme?.nombre],
    colorTercero: colorTercero[activeTheme?.nombre],
    colorCuarto: colorCuarto[activeTheme?.nombre],
    colorQuinto: colorQuinto[activeTheme?.nombre],
    colorSexto: colorSexto[activeTheme?.nombre],
    colorSeptimo: colorSeptimo[activeTheme?.nombre],
    logo: logo[activeTheme?.nombre],
    imgLineas: imgLineas[activeTheme?.nombre],
  };
};

export default useThemes;
